<template>
    <div class="price-box">
        <PriceBox
            :has-discount="hasDiscountPrice"
            :discount-price="productDiscountPrice"
            :main-price="productMainPrice"
            :price="productPrice"
            :price-without-tax="productWithoutTaxPrice"
            :currency="currency"
        />

        <!-- <Variations v-if="hasVariations"
            :variations="variations"
            :currency="currency"
            :current-product-id="productId"
        /> -->

        <div class="add-to-cart-wrapper">

            <QuantityInput :step="step" :mu="unit" v-if="parseFloat(stock) > 0" />

            <AddToCart
                :route="routeToCart"
                :product-id="productId"
                :btn-text="btnTextAddToCart"
                :btn-icon="btnIcon"
                :show-btn-text="true"
                :gtm-data-p="gtmDataP"
                v-if="parseFloat(stock) > 0"/>

            <WatchDog v-if="parseFloat(stock) < 0.01"/>

            <WatchDogModal
                v-if="parseFloat(stock) < 0.01"
                :title="modalTitle"
                :text-close="modalTextClose"
                :text-confirm="modalTextConfirm"
                :text-gdpr="modalTextGdpr"
                :form-action="modalFormAction"
                :csrf="csrf"
                :productId="productId"
                :antispam="antispam"
                :gdprValue="gdprValue"/>
        </div>

        <div class="stock-info" v-if="stock > 0">
            <p><strong>{{ inStockText }} {{ stock }} {{ unit }}</strong> - {{ deliveryTimeText }}</p>
        </div>

        <div class="stock-info out-of-stock" v-if="stock < 0.01">
            <p><strong>{{ inStockText }} {{ stock }} {{ unit }}</strong></p>
        </div>
    </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue'

import AddToCart from '../../buttons/AddToCart.vue'
import QuantityInput from '../../inputs/QuantityInput.vue'
import WatchDog from '../../buttons/WatchDog.vue'
import WatchDogModal from '../../modals/WatchDogModal.vue'
// import Variations from './Variations.vue'
import PriceBox from './PriceBox.vue'

import emitter from '../../../utils/emitter'

export default {

    props: [
        'routeToCart',
        'productId',
        'btnTextAddToCart',
        'stock',
        'inStockText',
        'deliveryTimeText',
        'inStockTooltip',
        'modalContent',
        'modalImage',
        'hasDiscountPrice',
        'productMainPrice',
        'productDiscountPrice',
        'productPrice',
        'productWithoutTaxPrice',
        'productCode',
        'hasVariations',
        'variations',
        'currency',
        'csrf',
        'antispam',
        'unit',
        'btnIcon',
        'modalTitle',
        'modalTextClose',
        'modalTextConfirm',
        'modalTextGdpr',
        'modalFormAction',
        'gdprValue',
        'step',
        'gtmDataP'
    ],

    components: {
        /* Variations, */
        AddToCart,
        QuantityInput,
        WatchDogModal,
        WatchDog,
        PriceBox
    },

    setup(props) {

        const state = reactive({
            stock: props.stock,
            routeToCart: props.routeToCart,
            productId: props.productId
        })

        onMounted( () => {

            emitter.on('variationChange', (data) => {
                state.stock = data.stock
                state.routeToCart = data.ajaxUrl
                state.productId = data.id
            })
        })

        return {
            ...toRefs(state)
        }
    }
}
</script>
